import { useCallback } from "react";
import { useNavigate, useLocation } from "react-router";
import useQueryParams from "./useQueryParams";

export default function useQueryParamModal(paramName, { clearParams = [] } = {}) {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = useQueryParams();
  const extraParamsKey = clearParams.join(",");

  const isOpen = queryParams.has(paramName);

  const open = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.set(paramName, "true");
    navigate({ search: params.toString() });
  }, [navigate, location.search, paramName]);

  const close = useCallback(() => {
    const params = new URLSearchParams(location.search);
    params.delete(paramName);
    extraParamsKey.split(",").filter(Boolean).forEach(key => params.delete(key));
    navigate({ search: params.toString() }, { replace: true });
  }, [navigate, location.search, paramName, extraParamsKey]);

  return { isOpen, open, close };
}
